// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const FormValidation = t.struct({
    approvalDate: t.Bool,
    purchaseOrder: t.Bool,
    responsibleAccount: t.Bool,
    retailerName: t.Bool,
    setupDate: t.Bool,
    storeNumber: t.Bool,
    workOrderOne: t.Bool,
    workOrderThree: t.Bool
}, 'FormValidation');

export const getDefaultState = () => new FormValidation({
    approvalDate: true,
    purchaseOrder: true,
    responsibleAccount: true,
    retailerName: true,
    setupDate: true,
    storeNumber: true,
    workOrderOne: true,
    workOrderThree: true
});

export default FormValidation;



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/state/form-validation.js